import HttpClienteToken from '../../services/HttpClientToken';

import { TipoAnexoProps } from '../../interfaces/catalogos/TipoAnexoInterface';

export const TipoAnexo = () => {

    return new Promise<TipoAnexoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoAnexo/', token)
            .then( ({ data } : { data : TipoAnexoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoAnexo = () => {

    return new Promise<TipoAnexoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoAnexo/ObtenerTipoAnexo', token)
            .then( ({ data } : { data : TipoAnexoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoAnexo = ( params: TipoAnexoProps ) => {

    return new Promise<TipoAnexoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoAnexo/Actualizar', params, token)
            .then( ({ data } : { data : TipoAnexoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoAnexo: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarTipoAnexo = ( params: TipoAnexoProps ) => {

    return new Promise<TipoAnexoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoAnexo/Agregar', params, token)
            .then( ({ data } : { data : TipoAnexoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoAnexo: 0,                   
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}